<template>
  <div class="selected-articles-list">
    <div class="header">
      <h4 class="count">เลือกแล้ว {{ count }} ข่าว</h4>
      <sc-button
        class="remove-all-button"
        v-if="showRemoveAllButton"
        :disabled="disabledRemoveButton"
        @click="handleClickRemoveAllButton"
        >ลบทั้งหมด</sc-button
      >
    </div>
    <div class="list-body">
      <div class="empty" v-if="isEmpty">ไม่มีข่าวที่เลือก</div>
      <draggable
        class="list"
        v-model="sortedValue"
        v-bind="dragOptions"
        @start="drag = true"
        @end="handleDragEnd"
      >
        <articles-selector-option
          class="selected-item"
          v-for="item in sortedValue"
          :key="item.id"
          v-bind="item"
          :canRemove="canRemove"
          @remove="handleRemoveSelectService(item)"
        ></articles-selector-option>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ArticlesSelectorOption from "./ArticlesSelectorOption";
import ScButton from "@/lib/components/ScButton";
export default {
  components: {
    draggable,
    ArticlesSelectorOption,
    ScButton
  },
  props: ["value", "disabled"],
  data() {
    const drag = false;
    const sortedValue = [];
    return {
      drag,
      sortedValue
    }
  },
  computed: {
    isEmpty() {
      return this.value.length === 0;
    },
    count() {
      return this.value.length;
    },
    disabledRemoveButton() {
      return this.isEmpty || !this.canRemove;
    },
    canRemove() {
      return !this.disabled;
    },
    showRemoveAllButton() {
      return this.canRemove;
    },
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    value: function(oldVal, newVal) {
      this.sortedValue = this.value;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.sortedValue = this.value;
    },
    handleRemoveSelectService(service) {
      this.$emit("remove", service);
    },
    handleClickRemoveAllButton() {
      this.$emit("removeAll");
    },
    handleDragEnd(event) {
      this.drag = false
      this.$emit("sortedValue", this.sortedValue);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.selected-articles-list {
  border: $border;
  border-radius: $border-radius;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.list {
  padding-bottom: 15px;
  overflow: auto;
  cursor: grabbing;
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;

  border-bottom: $border;

  > .remove-all-button {
    height: 42px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;

    &:hover,
    &:focus {
      border-color: #dcdfe6 !important;
    }
  }
}

.selected-articles-list > .list-body {
  overflow-y: auto;
  height: 500px;
}

.empty {
  padding: 20px 0;
  text-align: center;
}

.count {
  margin: 0;
  padding: 10px ($space / 2);

  color: $primary-color;
  font-size: 1.1rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ArticlesSelector/SelectedArticlesList.vue